module.exports = __webpack_public_path__ + "img/img4.f44f4037.svg";